import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface CarouselImage {
  src: string;
  alt: string;
  title: string;
  timestamp: Date;
}

export interface ImageCarouselSignature {
  Args: {
    images: CarouselImage[];
    nextLabel?: string;
    previousLabel?: string;
  };
}

export default class ImageCarousel extends Component<ImageCarouselSignature> {
  @tracked
  activeImageIndex = 0;

  get activeImage() {
    return this.args.images[this.activeImageIndex] as CarouselImage;
  }

  @action
  setActiveImage(index: number) {
    this.activeImageIndex = index;
  }

  @action
  nextImage() {
    this.activeImageIndex = (this.activeImageIndex + 1) % this.args.images.length;
  }
  @action
  previousImage() {
    this.activeImageIndex =
      this.activeImageIndex === 0 ? this.args.images.length - 1 : this.activeImageIndex - 1;
  }
}
